

















































































































































import { Component, Watch } from "vue-property-decorator";
import { InvitationInterface } from "@/resources/interfaces/invitationInterface";
import moment from "moment";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { INVITATION_TYPE } from "@/resources/constants/invitation";
@Component({
  name: "pending-invitations-component",
})
export default class PendingInvitationsComponent extends mixins(
  NotificationEvent
) {
  loader = true;
  search = "";
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  confirmDelete = false;
  confirmIncrease = false;
  invitationId = 0;
  loading = false;
  @Watch("currentPage")
  updatePage(): void {
    this.getInvitations();
  }
  mounted(): void {
    this.$store.dispatch("InvitationStore/deleteInvitationsAction");
    this.getInvitations();
  }
  get invitations(): Array<InvitationInterface> {
    return this.$store.getters["InvitationStore/getInvitations"];
  }
  momentDate(date): string {
    return moment(date).format("MMMM DD YYYY, HH:mm");
  }
  getInvitation(type: string): string {
    switch (type) {
      case INVITATION_TYPE.SPACE_TOKEN_USER_INVITATION:
        return this.$i18n.t("labels.publicInvitationType").toString();
      case INVITATION_TYPE.TARGET_USER_INVITATION:
      case INVITATION_TYPE.TARGET_GUEST_INVITATION:
        return this.$i18n.t("labels.customInvitationType").toString();
    }
  }
  getType(invitation: string): string {
    switch (invitation) {
      case INVITATION_TYPE.SPACE_TOKEN_USER_INVITATION:
      case INVITATION_TYPE.TARGET_USER_INVITATION:
        return this.$i18n.t("labels.userInvitationType").toString();
      case INVITATION_TYPE.TARGET_GUEST_INVITATION:
        return this.$i18n.t("labels.invitedInvitationType").toString();
    }
  }
  getInvitations(): void {
    this.loader = true;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const selectedSpaceCustomize = space;
    this.$store.dispatch("InvitationStore/setInvitationsAction", {
      spaceId: selectedSpaceCustomize.id,
      page: this.currentPage,
      callback: (response) => {
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        this.itemsPerPage = parseInt(
          response.headers["pagination-items-per-page"]
        );
        this.loader = false;
      },
      callbackError: (error) => {
        this.loader = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
  deleteInvitation() {
    this.loading = true;
    this.$store.dispatch("InvitationStore/removeInvitationAction", {
      invitationId: this.invitationId,
      callback: (response) => {
        this.loading = false;
        this.confirmDelete = false;
        if (response.data.status === "KO") {
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t(`notifications.apiMessage.${response.data.code}`)
          );
        } else {
          this.onSuccess(
            this.$i18n.t("notifications.titles.success"),
            this.$i18n.t("notifications.descriptions.deleteInvitation")
          );
        }
      },
    });
  }
  increaseInvitation() {
    this.loading = true;
    this.$store.dispatch("InvitationStore/increaseInvitationAction", {
      invitationId: this.invitationId,
      callback: (response) => {
        this.loading = false;
        this.confirmIncrease = false;
        if (response.data.status === "KO") {
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t(`notifications.apiMessage.${response.data.code}`)
          );
        } else {
          this.onSuccess(
            this.$i18n.t("notifications.titles.success"),
            this.$i18n.t("notifications.descriptions.increaseInvitation")
          );
        }
      },
    });
  }
}
